/* Ninja AI background removal for Patches (Owen 2026-10-29: replace the
   imgix remover with Wil's Ninja AI, ranked job, Rank 1 kept — the same single
   result the Ninja Transfers portal/puff pages use).

   Wil's client (nt-bgr-client.js) and stock provider (nt-bgr-stock-provider.js)
   come from Ninja-Website. The client has an opt-in nativeResultOnly patch for
   Patches, which renders the saved artwork itself. This file adapts them to
   the Patches builders. It never decides anything the old remover did not:

   - cutout(url) starts (or reuses) one ranked job per source and resolves with
     { url, service } — url is Wil's durable saved PNG on ninjauploads imgix
     (savedUrl: displayBox rect, or colorUnlessAlpha trim), service is the
     stable model code of the Rank 1 winner (e.g. ninja_ai_8KBI).
   - peek(url) is the synchronous view for render paths: the result once
     ready, otherwise null. state(url) says ready / pending / failed. As on
     Ninja Transfers, the old remover is not shown (or billed) while Ninja is
     working — the original shows — and imgix bg-remove is the fallback only
     once the job fails, so a failure ends up looking exactly like today.
   - Rasters only. Vectors keep the authored original (production source).
   - When a job finishes, 'np-ninja-bgr:ready' fires on document with
     { source, url, service } so the builder re-renders from the cutout.

   The client refuses origins outside Wil's list before any network call
   (ninjapoddd.myshopify.com is not on it — test on ninjapatches.com
   ?preview_theme_id=…). The API also validates the origin and signed receipts. */
(function () {
  'use strict';
  if (window.NpNinjaBgr) return;
  var cfg = window.NpNinjaBgrAssets || {};
  var SERVICE = { 's3od-binary8k-e10': 'ninja_ai_8KBI', 's3od-binary51544-e40': 'ninja_ai_51KBI',
    'max-local-regular-e30': 'ninja_ai_40KRG', 's3od-removal22890-c10': 'ninja_ai_23KRO' };
  var NINJA_OUT = /\/image-ai-test____[a-f0-9]{64}\.png$/i;
  var results = {}, pending = {}, failed = {}, clientP = null, seq = 0;

  function bare(u) { return String(u || '').split('?')[0].split('#')[0]; }
  function raster(u) { return /\.(png|jpe?g|jfif|bmp|webp|heic|heif|avif|tiff?)$/i.test(bare(u)); }
  function isNinja(u) { return NINJA_OUT.test(bare(u)); }
  /* finished results survive a same-tab page change (Patch Express → product page), so the
     handoff never runs a second job for the same upload */
  var SS_KEY = 'npNinjaBgr:';
  function stored(src) {
    try { var v = JSON.parse(sessionStorage.getItem(SS_KEY + src) || 'null'); if (v && isNinja(v.url) && v.service) return (results[src] = v); } catch (e) {}
    return null;
  }
  function load(src, ok) {
    return new Promise(function (res, rej) {
      if (ok()) return res();
      if (!src) return rej(new Error('asset missing'));
      var s = document.createElement('script'); s.src = src; s.async = true;
      s.onload = function () { ok() ? res() : rej(new Error('no global')); }; s.onerror = rej;
      document.head.appendChild(s);
    });
  }
  function client() {
    clientP = clientP || load(cfg.client, function () { return !!window.NinjaBackgroundRemoval; })
      .then(function () { return load(cfg.provider, function () { return !!window.NtBgrStockProvider; }); })
      .then(function () { return window.NinjaBackgroundRemoval.create({onDiagnostic:function (name, fields) {
        if (name !== 'fallback_detail') return;
        // Log only operational fields, never source URLs or signed receipts.
        var detail = {};
        ['reason','operation','failureKind','httpStatus','candidateModel','candidateRank','timeoutMs'].forEach(function (key) {
          if (fields[key] !== undefined) detail[key] = fields[key];
        });
        console.warn('[np-ninja-bgr] candidate unavailable', detail);
      }}); });
    clientP.catch(function () { clientP = null; });
    return clientP;
  }
  function cutout(url) {
    var src = bare(url);
    if (!src || !raster(src) || isNinja(src)) return Promise.reject(Object.assign(new Error('not a raster upload'), { code: 'unsupported' }));
    if (results[src] || stored(src)) return Promise.resolve(results[src]);
    if (failed[src]) return Promise.reject(failed[src]);
    if (pending[src]) return pending[src];
    var file = { id: 'np-' + (++seq), s3Url: src, uploadName: src.split('/').pop() };
    pending[src] = client()
      .then(function (c) { return c.remove(file, {nativeResultOnly:true}); })
      .then(function (r) {
        var key = (r.order || r.all.map(function (c) { return c.name; }))[0];
        var c = r.all.find(function (x) { return x.name === key; });
        var out = null;
        if (c && /^ninja/.test(c.name) && c.persistentUrl) {
          try { out = { url: window.NtBgrStockProvider.savedUrl(c), service: SERVICE[c.modelId] || 'Unknown' }; } catch (e) {}
        }
        try { if (r.dispose) r.dispose(); } catch (e) {}
        if (!out) throw Object.assign(new Error('no saved Ninja AI result'), {
          code: (c && c.fallbackReason) || file.ntAiFallbackReason || 'save_unavailable'
        });
        results[src] = out;
        try { sessionStorage.setItem(SS_KEY + src, JSON.stringify(out)); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('np-ninja-bgr:ready', { detail: { source: src, url: out.url, service: out.service } })); } catch (e) {}
        return out;
      })
      .catch(function (e) {
        failed[src] = e || new Error('unavailable');
        try { console.warn('[np-ninja-bgr] Ninja AI unavailable, keeping imgix bg-remove:', (e && (e.code || e.message)) || e); } catch (e2) {}
        try { document.dispatchEvent(new CustomEvent('np-ninja-bgr:failed', { detail: { source: src, code: (e && e.code) || 'unavailable' } })); } catch (e3) {}
        throw failed[src];
      })
      .then(function (v) { delete pending[src]; return v; }, function (e) { delete pending[src]; throw e; });
    return pending[src];
  }
  function peek(url) { var src = bare(url); return results[src] || stored(src); }
  /* the cart-line record of a Ninja cutout, or null when the URL is not one */
  function cartProps(url) {
    if (!isNinja(url)) return null;
    for (var k in results) if (bare(results[k].url) === bare(url)) return { '_BG Removal Service': results[k].service, '_BG Removal Rank Choice': 'Rank 1' };
    return null;
  }
  function onUploads(u) { return /^https:\/\/ninjauploads-production\.imgix\.net\//.test(String(u || '')); }
  /* where Ninja stands for an upload: 'ready' | 'pending' (running or not started yet) | 'failed' | '' (not a Ninja source) */
  function state(url) {
    var s = bare(url);
    if (!onUploads(s) || !raster(s) || isNinja(s)) return '';
    if (results[s] || stored(s)) return 'ready';
    return failed[s] ? 'failed' : 'pending';
  }
  /* resolves once the job for this upload has settled, or after maxMs; at once if none is running */
  function settled(url, maxMs) {
    var p = pending[bare(url)];
    if (!p) return Promise.resolve();
    return Promise.race([p.then(null, function () {}), new Promise(function (r) { setTimeout(r, maxMs); })]);
  }
  function withoutRemoval(u) {
    var b = bare(u), q = String(u).slice(b.length + 1).split('&').filter(function (kv) {
      return kv && !/^bg-remove(-model)?=/.test(kv);
    }).join('&');
    return q ? b + '?' + q : b;
  }

  /* NO OLD-REMOVER PREVIEW — the same rule as Ninja Transfers (bg-removal-multi.js, Owen 2026-10-29): a
     displayed <img> asking for the imgix bg-remove render of an upload Ninja is handling loads WITHOUT the
     bg-remove params (the original shows until the cut-out replaces it), and the imgix render is requested
     only once Ninja has failed for that upload. Asking also starts the job. Unlike Transfers, .src and
     getAttribute('src') keep answering the URL that was asked for: custom-uploader.js reads the hero back
     (getToggleParams) to build _Upload, which must keep its bg-remove. Detached images (new Image(), the
     sizing renders) are left alone. */
  function filtered(img, v) {
    v = v == null ? '' : String(v);
    var st = v.indexOf('bg-remove=true') > -1 && onUploads(v) ? state(v) : '';
    if (!st || st === 'failed' || !img.isConnected) { delete img.__npWant; return v; }
    if (st === 'pending') cutout(v).catch(function () {});
    img.__npWant = v;
    return withoutRemoval(v);
  }
  (function installPreviewFilter() {
    try {
      var P = HTMLImageElement.prototype, d = Object.getOwnPropertyDescriptor(P, 'src');
      if (!d || !d.set || P.__npNoOldRemoval) return;
      Object.defineProperty(P, 'src', { configurable: true, enumerable: d.enumerable,
        get: function () { return this.__npWant || d.get.call(this); },
        set: function (v) { d.set.call(this, filtered(this, v)); } });
      var setA = Element.prototype.setAttribute, getA = Element.prototype.getAttribute;
      Element.prototype.setAttribute = function (n, v) {
        if (this instanceof HTMLImageElement && String(n).toLowerCase() === 'src') v = filtered(this, v);
        return setA.call(this, n, v);
      };
      Element.prototype.getAttribute = function (n) {
        if (this.__npWant && this instanceof HTMLImageElement && String(n).toLowerCase() === 'src') return this.__npWant;
        return getA.call(this, n);
      };
      P.__npNoOldRemoval = true;
    } catch (e) { /* never block the page */ }
  })();
  /* Ninja failed for an upload: the images held on the original now load the imgix render (the fallback) */
  document.addEventListener('np-ninja-bgr:failed', function (e) {
    var src = e.detail && e.detail.source;
    Array.prototype.forEach.call(document.images, function (img) {
      if (img.__npWant && bare(img.__npWant) === src) img.setAttribute('src', img.__npWant);
    });
  });

  window.NpNinjaBgr = { cutout: cutout, peek: peek, isNinja: isNinja, raster: raster, cartProps: cartProps,
    state: state, settled: settled, withoutRemoval: withoutRemoval };
})();
